/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelEnumInterfaces.mustache
// synched 02.02.2023
import * as yup from 'yup';
import * as fastJSON from 'fast-json-stringify';
import { StringSchema } from 'fast-json-stringify';
/**
 *
 * @export
 * @enum {string}
 */
export enum DatasetType {
    Crops = 'Crops',
    Images = 'Images',
    Videos = 'Videos'
}
/* LIGHTLY CUSTOM START -> modelEnumInterfaces */
export const DatasetTypeValidatorShape = [
    'Crops',
    'Images',
    'Videos'
];
export const DatasetTypeValidator = yup.mixed().oneOf(DatasetTypeValidatorShape);
export const DatasetTypeStringifyShapeProperties = {};
export const DatasetTypeStringifyShape: StringSchema = {
    title: 'DatasetType Stringifier',
    type: 'string'
};
export const DatasetTypeStringify = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(DatasetTypeStringifyShape)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
/* LIGHTLY CUSTOM END */
export function DatasetTypeFromJSON(json: any): DatasetType {
    return DatasetTypeFromJSONTyped(json, false);
}
export function DatasetTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatasetType {
    return json as DatasetType;
}
export function DatasetTypeToJSON(value?: DatasetType | null): any {
    return value as any;
}
